// extracted by mini-css-extract-plugin
export default {"products":"ProductsList_products__lTrFR","meals-appear":"ProductsList_meals-appear__p4Yya","products-appear":"ProductsList_products-appear__zTgZd"};